import { observable, action } from "mobx";
import {getByAtribute} from "../../../utils/formatar";
import qs from "query-string";
import {getMensagemDeErro} from "../../../utils/functions";

export default class TabelaFiltroStore {
    @observable errors;

    constructor() {
        this.errors = [];
    }

    addError = (error) => {
        this.errors.push(getMensagemDeErro(error))
    }
}
